import CommentContent from './CommentContent';

export default CommentContent;
